import axios from "axios";


export const getUserBaseClientAccess = (userId) => {
  return axios
    .get(
      `${import.meta.env.VITE_ADMIN_API}/api/user/getuserbaseclientaccess/${encodeURIComponent(userId)}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    )
    .then((res) => {
      return res.data;
    });
};
